<template>
  <div>
    <content-loader
      v-if="placeholder"
      :height="385"
      :width="290"
      :speed="2"
      primaryColor="#f3f3f3"
      secondaryColor="#ecebeb"
      :style="{ marginBottom: 1.875 + 'rem' }"
    ></content-loader>
    <div v-else class="card align-items-center">
      <div
        class="card-img-top"
        :style="{ 'background-image': 'url(' + featuredImage + ')' }"
      />
      <router-link
        :to="'/art/' + username"
        tag="img"
        class="artist-avatar rounded-circle"
        :src="avatar"
        :alt="fullName + 'avatar'"
      />
      <div class="link-wrapper">
        <h4 class="card-title ellipsis mb-1">{{ fullName || username }}</h4>
        <div class="card-text ellipsis mb-0">
          {{ location || "Undisclosed Location" }}
        </div>
        <router-link class="profile-link ellipsis" :to="'/art/' + username"
          >@{{ username
          }}<verified-badge v-if="isVerified" size="smmd" :showTooltip="false"
        /></router-link>
      </div>
      <follow-button class="mb-4" :artist_id="artistId" type="primary" />
    </div>
  </div>
</template>

<script>
import { ContentLoader } from "vue-content-loader";
import VerifiedBadge from "./VerifiedBadge.vue";
import FollowButton from "../components/FollowButton.vue";
const cdnBaseURL = process.env.VUE_APP_CDN_BASE_URL;

export default {
  name: "featured-artist-card",
  data() {
    return {};
  },
  props: {
    fullName: {
      type: String,
      default: "",
      description: "Artist's full name",
    },
    location: {
      type: String,
      default: "",
      description: "Artist's location",
    },
    username: {
      type: String,
      description: "Artists username",
    },
    featuredImage: {
      type: String,
      description: "Artist's featured image url",
    },
    avatar: {
      type: String,
      description: "Artist's avatar url",
    },
    foundingArtist: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: Boolean,
      default: false,
      description: "Toggle the card placeholder",
    },
    artistId: {
      type: String,
      description: "Artist Id",
    },
    isVerified: {
      type: Boolean,
      default: false,
    },
  },
  computed: {},
  components: {
    ContentLoader,
    FollowButton,
    VerifiedBadge,
  },
};
</script>

<style scoped lang="scss">
.card {
  width: 91%;
  margin-left: auto;
  margin-right: auto;
}
.link-wrapper {
  width: 100%;
  padding: 0 0.5rem;
}
.card-img-top {
  height: 250px;
  background-position: center center;
  background-size: cover;
  background-color: black;
}
.card-title {
  font-size: 1.125rem;
  margin-top: 1.5rem;
  line-height: 1.4;
}
.ellipsis {
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: block;
}
.profile-link {
  font-size: 0.875rem;
  font-weight: 700;
  margin-bottom: 1rem;
  margin-top: 0.25rem;
  color: black;
}
.artist-avatar {
  width: 140px;
  height: 140px;
  margin-top: -70px;
  border: 2px solid white;
  cursor: pointer;
  object-fit: cover;
}

.founding-sticker {
  background: black;
  border-radius: 20px;
  padding: 2.5px 8px;
  font-size: 0.75rem;
  color: white;
  position: absolute;
  top: 10px;
  z-index: 1;
}

@media (max-width: 575.98px) {
  .card-img-top {
    height: 200px;
  }

  .artist-avatar {
    width: 80px;
    height: 80px;
    margin-top: -40px;
  }

  .card-title {
    // font-size: 0.75rem;
    margin-top: 1rem;
  }

  // .card-text,
  // .profile-link {
  //   font-size: 0.625rem;
  // }

  .profile-link {
    margin-bottom: 1rem;
  }
}
</style>
